













































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('Country', {
      countries: 'countries',
    }),
  },
})
export default class BusinessCreditCheckReview extends Vue {
  @Prop() readonly referee1!: Referee;
  @Prop() readonly referee2!: Referee;
  @Prop() readonly business!: Model;

  countries!: [
    {
      id: number;
      name: string;
      states: {
        id: number;
        name: string;
      }[];
    }
  ];

  toAddress(v) {
    let address = v.address1;
    if (v.address2) {
      address += ', ' + v.address2;
    }
    if (v.city) {
      address += ', ' + v.city;
    }
    if (v.postcode) {
      address += ', ' + v.postcode;
    }
    if (v.state_id && v.country_id) {
      const country = this.countries.find(
        (country) => country.id == v.country_id
      );
      const state = country?.states.find((state) => state.id == v.state_id);
      if (country && state) {
        address += ', ' + state.name + ', ' + country.name;
      }
    }
    return address;
  }
}
